import { render } from "./DisplayHandMadeKey.vue?vue&type=template&id=0cd48d20"
import script from "./DisplayHandMadeKey.vue?vue&type=script&lang=js"
export * from "./DisplayHandMadeKey.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__